import React from 'react';
import { useLocation } from 'react-router-dom';
import { usePermission } from '../../contexts/PermissionContext';

/**
 * UI affordance gate — sembunyikan elemen dari DOM jika user tidak punya hak.
 * Jangan gunakan disabled; prefer unmount untuk affordance yang jelas.
 *
 * @param {string} action - create | read | update | delete | canCreate | ...
 * @param {string} [path] - path override; default: lokasi aktif
 * @param {React.ReactNode} children
 */
const Can = ({ action, path, children }) => {
  const location = useLocation();
  const { isMenuLoading, can } = usePermission();
  const targetPath = path || location.pathname;

  if (isMenuLoading) return null;
  if (!can(action, targetPath)) return null;

  return children;
};

export default Can;
